import { css } from '@emotion/core';
import { variables, media, tokens } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
var font = variables.font;
var colors = tokens.colors;
var headingL = typography.headingL;
export var container = {
  name: "1baulvz",
  styles: "display:inline-block;"
};
export var heading = /*#__PURE__*/css(headingL, ";color:", colors.neutral.heavy.default, ";");
export var items = /*#__PURE__*/css("margin-bottom:24px;", media('>=tablet'), "{display:inline-block;width:400px;column-count:3;margin-bottom:40px;}");
export var item = /*#__PURE__*/css("display:inline-block;margin-right:20px;text-decoration:none;color:", colors.neutral.heavy.default, ";white-space:nowrap;margin-top:12px;font-size:", font.smallFontSize, ";line-height:1em;&:hover{", media('>=tablet'), "{text-decoration:underline;}}", media('>=tablet'), "{width:100px;margin-right:0;}");
export var itemLink = /*#__PURE__*/css("text-decoration:none;color:", colors.neutral.heavy.default, ";");